import type { UserPreferencesNotificationsTableProps } from "./user-preferences-notifications-table.type";
import type { NotificationsReferential } from "@/entities/referential/referential-notifications";
import type { TableProps } from "antd";

import { Table, Typography, Space, Flex } from "antd";

import { UserPreferencesNotificationsSectionActions } from "../user-preferences-notifications-section-actions";
import { UserPreferencesNotificationsSwitch } from "../user-preferences-notifications-switch";
import { UserPreferencesNotificationsTableColumnHeader } from "../user-preferences-notifications-table-column-header";

import "./user-preferences-notifications-table.style.less";

const { Title, Text } = Typography;

export const UserPreferencesNotificationsTable = ({
  title,
  notifications,
}: UserPreferencesNotificationsTableProps) => {
  const columns: TableProps<NotificationsReferential>["columns"] = [
    {
      title: (
        <Flex gap="small" align="center">
          <Title level={3}>{title}</Title>
          <UserPreferencesNotificationsSectionActions
            notifications={notifications}
          />
        </Flex>
      ),
      dataIndex: "notification",
      width: "55%",
      render: (_, { name, description }) => (
        <Space orientation="vertical" size={0}>
          <Text strong>{name}</Text>
          <Typography.Text type="secondary">{description}</Typography.Text>
        </Space>
      ),
    },
    {
      title: (
        <UserPreferencesNotificationsTableColumnHeader
          channel="database"
          notifications={notifications}
        />
      ),
      dataIndex: "channels",
      align: "center",
      width: "15%",
      render: (_, { slug }) => (
        <UserPreferencesNotificationsSwitch
          channel="database"
          notificationKey={slug}
        />
      ),
    },
    {
      title: (
        <UserPreferencesNotificationsTableColumnHeader
          channel="broadcast"
          notifications={notifications}
        />
      ),
      dataIndex: "channels",
      align: "center",
      width: "15%",
      render: (_, { slug }) => (
        <UserPreferencesNotificationsSwitch
          channel="broadcast"
          notificationKey={slug}
        />
      ),
    },
    {
      title: (
        <UserPreferencesNotificationsTableColumnHeader
          channel="mail"
          notifications={notifications}
        />
      ),
      dataIndex: "channels",
      align: "center",
      width: "15%",
      render: (_, { slug }) => (
        <UserPreferencesNotificationsSwitch
          channel="mail"
          notificationKey={slug}
        />
      ),
    },
  ];

  return (
    <Table
      rowKey="slug"
      className="user-preferences-notifications-table"
      classNames={{
        header: {
          wrapper: "user-preferences-notifications-table--header",
          cell: "user-preferences-notifications-table--th",
        },
      }}
      columns={columns}
      dataSource={notifications}
      pagination={false}
      showHeader
    />
  );
};
